import React, { useState } from 'react';
import styled from 'styled-components';
import bgImg from '../../Asset/img/sheap.png';
import sideImg from '../../Asset/img/bluspace-w.png';
import { useNavigate } from 'react-router-dom';
const Auth = ({ myAdmin }) => {
  const navigate = useNavigate();
  const [formBox, setFormBox] = useState(false);
  const [signUp, setSignUp] = useState(false);
  return (
    <AuthWrapper>
      <AuthContainer>
        <LeftBox>
          <img
            src={sideImg}
            alt="logo"
            onDoubleClick={() => {
              navigate('/');
              myAdmin(false);
            }}
          />
        </LeftBox>
        <RightBox
          onDoubleClick={() => {
            setFormBox(true);
          }}>
          <div className="rest">
            <span>!</span>
            <h1>Admin's Only No Trespassing</h1>
          </div>
          {formBox && (
            <div
              className="authForm"
              onPointerLeave={() => {
                setFormBox(!formBox);
              }}>
              <LoginWrapper>
                {!signUp ? (
                  <div className="form-container login">
                    <form>
                      <div className="in-box">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email Address"
                        />
                      </div>
                      <div className="in-box">
                        <input
                          type="password"
                          name="password"
                          placeholder="Password"
                        />
                      </div>
                      <div className="in-box">
                        <button type="button">Sign In</button>
                      </div>
                      <span
                        onClick={() => {
                          setSignUp(true);
                        }}>
                        Don't have account?
                      </span>
                    </form>
                  </div>
                ) : (
                  <div className="form-container register">
                    <form>
                      <div className="in-box">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email Address"
                        />
                      </div>
                      <div className="in-box">
                        <input
                          type="password"
                          name="password"
                          placeholder="Password"
                        />
                      </div>
                      <div className="in-box">
                        <input
                          type="password"
                          name="confirmPass"
                          placeholder="Confirm Password"
                        />
                      </div>
                      <div className="in-box">
                        <button type="button">Sign Up</button>
                      </div>
                      <span
                        onClick={() => {
                          setSignUp(!signUp);
                        }}>
                        Already a user?
                      </span>
                    </form>
                  </div>
                )}
              </LoginWrapper>
            </div>
          )}
        </RightBox>
      </AuthContainer>
    </AuthWrapper>
  );
};

const AuthWrapper = styled.section`
  min-height: 100vh;
  background: linear-gradient(
      175deg,
      rgba(1, 35, 49, 0.925),
      rgba(3, 14, 26, 0.932)
    ),
    url(${bgImg});
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AuthContainer = styled.article`
  height: 80vh;
  width: 65%;
  background: var(--main-color);
  border-radius: 0.2rem;
  box-shadow: 0 0.5rem 1rem var(--bga-color);
  display: grid;
  grid-template-columns: 40% 60%;
`;

const LeftBox = styled.div`
  display: flex;
  align-items: center;
  background: var(--bg-color);
  img {
    width: 100%;
  }
`;

const RightBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .rest {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    span {
      font-size: 3rem;
    }
    h1 {
      color: var(--bg-color);
      font-weight: 700;
      text-align: center;
    }
  }
  .authForm {
    background: rgb(255, 255, 255);
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
  }
`;

const LoginWrapper = styled.div`
  .form-container {
    min-height: 80vh;
    display: flex;
    align-items: center;
    width: 100%;
    form {
      width: 85%;
      margin: 0 auto;
      .in-box {
        width: 80%;
        margin: 2% auto;
        input,
        button {
          width: 100%;
          padding: 13px 20px;
          border-radius: 0.2rem;
          box-shadow: 0 0 10px var(--bga-color);
          font-size: 18px;
        }
        button {
          font-weight: 700;
          background: var(--bg-color);
          color: var(--main-color);
          cursor: pointer;
        }
      }
      span {
        color: var(--bg-color);
        cursor: pointer;
        float: right;
        font-size: 14px;
        font-weight: 700;
        text-decoration: underline;
        margin-right: 10%;
        padding-top: 5px;
      }
    }
  }
`;

export default Auth;
